// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"61818587","787":"879ba5e2","931":"f8de9ae4"}[chunkId] + ".chunk.js";
};